import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = ["href"];
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("link", {
    rel: "stylesheet",
    href: "https://unpkg.com/element-plus@2.2.28/dist/index.css"
}, null, -1);
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { mapping_Name_To_Title } from "./router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup: function (__props) {
        var _a, _b;
        var include = ref([]);
        var route = useRoute();
        var router = useRouter();
        window.reg_SubRouter__VueRouter(router, mapping_Name_To_Title);
        window.reg_SubRouter__VueApp(router, route, mapping_Name_To_Title);
        window.add_HeaderTabsChangeListener(function (res_include) {
            //@ts-ignore
            include.value = res_include.map(function (item) { return mapping_RouterPath_To_Name(item.sub_route_path); });
        });
        function mapping_RouterPath_To_Name(path) {
            var i = path.indexOf('?');
            console.log("mapping_RouterPath_To_Name", path);
            if (!~i) {
                // 无query参数
                return path.slice(path.lastIndexOf('/') + 1);
            }
            else {
                return path.slice(path.lastIndexOf('/', i) + 1, i);
            }
        }
        var global_style = ref(((_b = (_a = window.$wujie.props) === null || _a === void 0 ? void 0 : _a.__SYSTEM_CONFIG__) === null || _b === void 0 ? void 0 : _b.GLOBAL_STYLE) || []);
        return function (_ctx, _cache) {
            var _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(global_style.value, function (item) {
                    return (_openBlock(), _createElementBlock("link", {
                        rel: "stylesheet",
                        href: item,
                        key: item
                    }, null, 8, _hoisted_1));
                }), 128)),
                _hoisted_2,
                _createVNode(_unref(ElConfigProvider), { locale: _unref(zhCn) }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_router_view, null, {
                            default: _withCtx(function (_a) {
                                var Component = _a.Component;
                                return [
                                    (_openBlock(), _createBlock(_KeepAlive, { include: include.value }, [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                                    ], 1032, ["include"]))
                                ];
                            }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                }, 8, ["locale"])
            ], 64));
        };
    }
});
